import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isNil from 'lodash/isNil';

import { MaterialHint } from 'shared/components';

import DefaultIconWithDotBadge from './DefaultIconWithDotBadge';

const propTypes = {
  title: PropTypes.object,
};

const defaultProps = {
  title: null,
};

const IconWithDotBadge = ({ title, ...props }) => {
  if (isNil(title)) {
    return <DefaultIconWithDotBadge { ...props } />;
  }

  return (
    <MaterialHint
      placement="top"
      title={ <FormattedMessage { ...title } /> }
    >
      <div>
        <DefaultIconWithDotBadge { ...props } />
      </div>
    </MaterialHint>
  );
};

IconWithDotBadge.propTypes = propTypes;
IconWithDotBadge.defaultProps = defaultProps;

export default IconWithDotBadge;
